import { render } from "./CurrentBasket.vue?vue&type=template&id=bf1bcf3c"
import script from "./CurrentBasket.vue?vue&type=script&lang=js"
export * from "./CurrentBasket.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__